<div style="width: 100%;">
  <mat-card class="box">
      <div class="divtitle">
        <span class="flex-container" style="padding: 8px;">
          <h1 class="label">{{'users.label' | transloco}}</h1>
          <button mat-raised-button color="primary" routerLink="/user" >{{'users.new' | transloco}}</button>
        </span>
      </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div>

      <div class="formBox">
        <form method="post" class="wrapper" >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="id">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >ID.</th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- first_name Column -->
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.name' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
            </ng-container>

            <!-- last_name Column -->
            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.surname' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
            </ng-container>

            <!-- email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.email' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- role_id Column -->
            <ng-container matColumnDef="role_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.role' | transloco}}</th>
              <td mat-cell *matCellDef="let element" [matTooltip]="getRoleHint(element.role_id)" matTooltipClass="multiline-tooltip"> {{ getRoleLabel(element.role_id) }} </td>
            </ng-container>

            <!-- company_id Column -->
            <ng-container matColumnDef="company_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.company' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.company_id}} </td>
            </ng-container>

            <!-- confirmed Column -->
            <ng-container matColumnDef="confirmed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'users.confirmed' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" checked="{{element.confirmed}}"></mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let j =index;"
            (click)="onRowClicked(row); $event.stopPropagation()" tabindex="0" (keydown.enter)="onRowClicked(row)"
            [ngClass]="{'row1':j%2 === 0 , 'row2':j%2 != 0 }"> </tr>

          </table>
          
          <div class="divPag">
            <mat-paginator [pageSizeOptions]="[9, 10, 20, 50]"
                            showFirstLastButtons
                            aria-label="Select page">
            </mat-paginator>
          </div> 
        </form>
      </div>

  </div>
  </mat-card>
</div>

<div>
  <mat-card *ngIf="isLoading" class="center-loading">
    <mat-card-content style="margin: 20%;" >
      <mat-progress-spinner style="margin: 0 auto;" color="primary" mode='indeterminate'value='50'></mat-progress-spinner>
    </mat-card-content>
  </mat-card>
</div>
